/** @flow */
import React, { Component } from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import FeaturePermission from 'common/components/FeaturePermission';
import Page from 'common/components/Page';

import TutorialCard from './components/TutorialCard';
import PdfTutorialCard from './components/PdfTutorialCard';
import VideoModal from './components/VideoModal';
import { Colors } from '../../themes';
import UserAccessImg from './assets/acces_utilisateur.jpg';
import DashboardImg from './assets/tableau_de_bord.jpg';
import DefaultImg from './assets/default_image.jpg';
import pdfs from './domain/pdfs';

const SalesContainter = styled.div`
  display: flex;
  flex:1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

const TutorialContainer = styled.div`
    max-width: 980px;
    width: 100%;
`;

const TutorialTitle = styled.p`
  font-size: 20px;
  color: ${Colors.primaryText};
  text-align: left;
  width: 100%;
`;

const TutorialSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
`;

type Props = {
  t: any,
}

type State = {
  videoId: string,
  title: string,
  isOpen: boolean,
};

export class TutorialPage extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      videoId: '',
      isOpen: false,
      title: '',
    };
    (this: any).openVideo = this.openVideo.bind(this);
  }

  openVideo(videoId: string, title: string) {
    this.setState({ isOpen: true, videoId: videoId, title: title });
  }

  render() {
    const { t } = this.props;

    return (
      <Page title={t('tutorialPageTitle')}>
        <SalesContainter>
          <TutorialContainer>
            <TutorialTitle>{t('introduction.title')}</TutorialTitle>
            <TutorialSection>
              <PdfTutorialCard title={t('introduction.platform')} pdf={pdfs.theGuide} page={13} image={DefaultImg} />
              <TutorialCard title={t('introduction.userAccessVideo')} onClick={() => this.openVideo(t('video.userAccess'), t('userAccess'))} image={UserAccessImg} />
              <PdfTutorialCard title={t('introduction.userAccess')} pdf={pdfs.theGuide} page={28} image={UserAccessImg} />
              <PdfTutorialCard title={t('introduction.dataDisseminationRules')} pdf={pdfs.dataDisseminationRules} page={1} image={DefaultImg} />
            </TutorialSection>
            <TutorialTitle>{t('programming.title')}</TutorialTitle>
            <TutorialSection>
              <TutorialCard title={t('programming.dashboardVideo')} onClick={() => this.openVideo(t('video.dashboard'), t('dashboard'))} image={DashboardImg} />
              <PdfTutorialCard title={t('programming.dashboard')} pdf={pdfs.theGuide} page={14} image={DefaultImg} />
              <PdfTutorialCard title={t('programming.history')} pdf={pdfs.theGuide} page={16} image={DefaultImg} />
              <PdfTutorialCard title={t('programming.reach')} pdf={pdfs.theGuide} page={17} image={DefaultImg} />
              <PdfTutorialCard title={t('programming.listeningTime')} pdf={pdfs.theGuide} page={19} image={DefaultImg} />
              <PdfTutorialCard title={t('programming.demography')} pdf={pdfs.theGuide} page={20} image={DefaultImg} />
            </TutorialSection>
            <TutorialTitle>{t('sales.title')}</TutorialTitle>
            <TutorialSection>
              <PdfTutorialCard title={t('sales.terms')} pdf={pdfs.advertisingTerms} image={DefaultImg} />
              <PdfTutorialCard title={t('sales.summary')} pdf={pdfs.theGuide} page={21} image={DefaultImg} />
              <PdfTutorialCard title={t('sales.estimation')} pdf={pdfs.theGuide} page={22} image={DefaultImg} />
            </TutorialSection>
            <FeaturePermission feature="FOLLO_MODULE">
              <TutorialTitle>{t('follo.title')}</TutorialTitle>
              <TutorialSection id="follo-tutorial-section">
                <PdfTutorialCard title={t('follo.campaignCreation')} pdf={pdfs.folloCreateCampaign} image={DefaultImg} />
                <PdfTutorialCard title={t('follo.addTimes')} pdf={pdfs.folloAddTimesCampaign} image={DefaultImg} />
                <PdfTutorialCard title={t('follo.campaignsStatistics')} pdf={pdfs.folloCampaignStatistics} image={DefaultImg} />
                <PdfTutorialCard title={t('follo.finishCampaign')} pdf={pdfs.folloFinishCampaign} image={DefaultImg} />
              </TutorialSection>
              <TutorialTitle>{t('follo.titleAdvertiser')}</TutorialTitle>
              <TutorialSection id="follo-advertiser-tutorial-section">
                <PdfTutorialCard title={t('follo.advertiser')} pdf={pdfs.folloAdvertiser} page={1} image={DefaultImg} />
                <PdfTutorialCard title={t('follo.platform')} pdf={pdfs.folloPlateform} page={1} image={DefaultImg} />
              </TutorialSection>
            </FeaturePermission>
            <TutorialTitle>{t('other')}</TutorialTitle>
            <TutorialSection>
              <PdfTutorialCard title={t('theGuide')} pdf={pdfs.theGuide} image={DefaultImg} />
            </TutorialSection>
          </TutorialContainer>
        </SalesContainter>
        <VideoModal title={this.state.title} open={this.state.isOpen} videoId={this.state.videoId} onClose={() => this.setState({ isOpen: false })} />
      </Page>
    );
  }
}

export default translate('tutorials')(TutorialPage);



// WEBPACK FOOTER //
// ./src/statsradio/modules/tutorials/TutorialPage.js